import React from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
// import OptionRow from "../components/OptionRow";
import WeServe from "../components/WeServe";
import Popular from "../components/Popular";
// import WhyUs from "../components/WhyUs";
import Footer from "../components/Footer";
import BottomNavbar from "../components/BottomNavbar";
import Faq from "../components/Faq";
import ProductRanges from "../components/ProductRanges";
import GoogleLoginModal from "../components/GoogleLoginModal";
import logo1 from "../assets/img/clients/client1.png";
import logo2 from "../assets/img/clients/client2.png";
import logo3 from "../assets/img/clients/client3.png";
import logo4 from "../assets/img/clients/client4.png";
import logo5 from "../assets/img/clients/client5.png";
import logo55 from "../assets/img/clients/client55.jpeg";
import logo6 from "../assets/img/clients/client6.jpeg";
import logo7 from "../assets/img/clients/client7.jpeg";
import logo8 from "../assets/img/clients/client8.jpeg";
import ClientSlider from "../components/ClientSlider";
import TestimonialSlider from "../components/TestimonialSlider";

const logos = [
  {
    id: 1,
    src: logo1,
    alt: "logo1",
  },
  {
    id: 2,
    src: logo2,
    alt: "logo2",
  },
  {
    id: 3,
    src: logo3,
    alt: "logo3",
  },
  {
    id: 4,
    src: logo4,
    alt: "logo4",
  },
  {
    id: 5,
    src: logo5,
    alt: "logo5",
  },
  {
    id: 6,
    src: logo6,
    alt: "logo6",
  },
  {
    id: 7,
    src: logo7,
    alt: "logo7",
  },
  {
    id: 8,
    src: logo8,
    alt: "logo8",
  },
  {
    id: 9,
    src: logo55,
    alt: "logo9",
  },
];

function Home() {
  return (
    <>
      <div className="bg-[#fcfcfc] font-serif">
        <Navbar current={"home"} />
        <Header />
        <ClientSlider logos={logos} />
        <Popular />
        <ProductRanges />
        <WeServe />
        <TestimonialSlider />
        <Faq />
        <Footer />
      </div>
      <BottomNavbar current="home" />
      <GoogleLoginModal />
    </>
  );
}

export default Home;
